import React, { useState, useEffect } from 'react'

import { Box } from '@material-ui/core'

//COMPONENTS
import OrderGroupCheckbox from '../OrderGroupCheckbox/OrderGroupCheckbox'
import OrderGroupRadio from '../OrderGroupRadio/OrderGroupRadio'

const OrderGroup = ({ group, singleProductOrder, setSingleProductOrder }) => {
  const { name, isRequired, type, key: groupId, options } = group

  const [checkedArray, setCheckedArray] = useState([])
  const [selectedValue, setSelectedValue] = useState('')

  useEffect(() => {
    handleProductOrder()
  }, [checkedArray, selectedValue])

  const handleProductOrder = () => {
    const groupIndex = singleProductOrder.groups.findIndex(
      (group) => group.key === groupId,
    )

    const updatedProductOrder = { ...singleProductOrder }
    if (type === 'checkbox') {
      if (checkedArray.length) {
        const selectedProducts = checkedArray.filter((item) => item.isDefault)

        updatedProductOrder.groups[groupIndex].options = selectedProducts
        setSingleProductOrder(updatedProductOrder)
      }
    } else {
      const getSelectedValue = group.options.find(
        (option) => option.key === selectedValue,
      )

      if (getSelectedValue) {
        updatedProductOrder.groups[groupIndex].options = [getSelectedValue]
        setSingleProductOrder(updatedProductOrder)
      }
    }
  }

  const handleType = () => {
    if (type === 'checkbox') {
      return (
        <OrderGroupCheckbox
          groupId={groupId}
          options={options}
          checkedArray={checkedArray}
          setCheckedArray={setCheckedArray}
          singleProductOrder={singleProductOrder}
        />
      )
    } else {
      return (
        <OrderGroupRadio
          groupId={groupId}
          options={options}
          selectedValue={selectedValue}
          setSelectedValue={setSelectedValue}
          singleProductOrder={singleProductOrder}
        />
      )
    }
  }

  return (
    <Box width="100%">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <h4>{name}</h4>

        <span style={{ color: '#999', fontWeight: 'bold', fontSize: '12px' }}>
          {isRequired ? 'Obligatorio' : 'Opcional'}
        </span>
      </Box>

      {handleType()}
    </Box>
  )
}

export default OrderGroup
